import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=c3d2b4b8&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=c3d2b4b8&prod&lang=scss&scoped=true"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&id=c3d2b4b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d2b4b8",
  null
  
)

export default component.exports